module.exports = __webpack_public_path__ + "bed3a22134438b290d52925f856a4b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/consult/consult-background.png
// module id = 324
// module chunks = 0